import React from 'react';
import { Phone, MapPin, Clock } from 'lucide-react';
import { businessInfo, images } from '../data/mock';

const Hero = () => {
  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img 
          src={images.hero}
          alt="Professional Vehicle Recovery"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900/95 via-slate-900/85 to-slate-900/70"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 relative z-10 pt-20">
        <div className="max-w-3xl">
          {/* Badge */}
          <div className="inline-flex items-center space-x-2 bg-blue-600/20 backdrop-blur-sm border border-blue-500/30 rounded-full px-4 py-2 mb-6 animate-fade-in">
            <div className="w-2 h-2 bg-blue-500 rounded-full animate-pulse"></div>
            <span className="text-blue-400 text-sm font-medium">Available 24/7 - Nationwide Coverage</span>
          </div>

          {/* Main Heading */}
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
            Fast & Reliable
            <span className="block text-blue-500">Vehicle Recovery</span>
          </h1>

          {/* Subheading */}
          <p className="text-xl md:text-2xl text-gray-300 mb-8 leading-relaxed">
            Professional breakdown recovery and towing services across the UK. 
            When you need help, we're just a phone call away.
          </p>

          {/* Quick Info Cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-10">
            <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-lg p-4 hover:bg-white/15 transition-all duration-200">
              <Clock className="w-8 h-8 text-blue-400 mb-2" />
              <p className="text-white font-semibold">24/7 Service</p>
              <p className="text-gray-300 text-sm">Always Available</p>
            </div>
            <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-lg p-4 hover:bg-white/15 transition-all duration-200">
              <MapPin className="w-8 h-8 text-blue-400 mb-2" />
              <p className="text-white font-semibold">Nationwide</p>
              <p className="text-gray-300 text-sm">Full UK Coverage</p>
            </div>
            <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-lg p-4 hover:bg-white/15 transition-all duration-200">
              <Phone className="w-8 h-8 text-blue-400 mb-2" />
              <p className="text-white font-semibold">Fast Response</p>
              <p className="text-gray-300 text-sm">Under 30 Minutes</p>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <a 
              href={`tel:${businessInfo.phone}`}
              className="group flex items-center justify-center space-x-3 bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-lg font-bold text-lg transition-all duration-200 hover:scale-105 shadow-xl hover:shadow-blue-500/50"
            >
              <Phone className="w-6 h-6 group-hover:animate-pulse" />
              <span>{businessInfo.phone}</span>
            </a>
            <button 
              onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
              className="flex items-center justify-center space-x-2 bg-white/10 backdrop-blur-md border-2 border-white/30 hover:bg-white/20 text-white px-8 py-4 rounded-lg font-bold text-lg transition-all duration-200 hover:scale-105"
            >
              <span>Get a Quote</span>
            </button>
          </div>
        </div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-slate-950 to-transparent z-10"></div>
    </section>
  );
};

export default Hero;
